import React, { Component } from 'react';
import { connect } from 'react-redux';
import OpenOrderDeliveryTracking from '../../../views/app/common/OpenOrderDeliveryTracking';
import { appActions } from '../../../store/modules/app';

class OpenOrderDeliveryTrackingContainer extends Component {
  render() {
    return <OpenOrderDeliveryTracking {...this.props} />;
  }
}

const mapDispatchToProps = {
  getOrderDeliveryTrackingData: appActions.getOrderDeliveryTrackingData,
};

export default connect(null, mapDispatchToProps)(OpenOrderDeliveryTrackingContainer);
